import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAppSelector } from 'src/redux/store/store';

import { ROUTE_LOGIN, GUEST_USER } from '../../constants';
import { CampaignTriggerContext } from 'src/context/CampaignTriggerContext';
import Loader from '../Loader/Loader';

interface PrivateRouteProps {
  component: React.ComponentType<any>;
}

const RequireAuth: React.FunctionComponent<PrivateRouteProps> = ({
  component: Component,
}) => {
  const { user } = useAppSelector((state) => state.user);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const category_id = query.get('category_id');

  const campaignContext = useContext(CampaignTriggerContext);

  const { campaignTriggerLoading } = campaignContext;
  if (campaignTriggerLoading) {
    return <Loader lightBg={true} />; // Placeholder for loading state
  }

  return user?.type !== GUEST_USER ? (
    <Component />
  ) : (
    <Navigate
      to={ROUTE_LOGIN}
      replace={true}
      state={{
        referrer: location.pathname,
        category_id: category_id,
      }}
    />
  );
};

export default RequireAuth;
